module.exports = __webpack_public_path__ + "img/MTR Logo.fe32784e.png";